// DraggableArtistNameTag.tsx
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Tag } from 'antd';
import { MenuOutlined } from '@ant-design/icons'; // Drag handle icon

interface DraggableArtistNameTagProps {
  id: string;
  name: string;
}

export const DraggableArtistNameTag: React.FC<DraggableArtistNameTagProps> = ({ id, name }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    cursor: 'grab', // Visual cue for grabbing
    userSelect: 'none', // Prevents text selection while dragging
  };

  return (
    <Tag ref={setNodeRef} style={style} {...attributes}>
        {/* Listeners are applied only to the drag handle */}
      <span {...listeners} style={{ touchAction: 'none', cursor: 'grab', paddingRight: '8px' }}>
        <MenuOutlined />
      </span>
      {name}
    </Tag>
  );
};